import type { MaybeRefOrGetter } from 'vue';
import type { GlobalPrimitiveFieldId } from '#layers/data-model';
import { computed, toValue } from 'vue';
import { useProjectSchemaStore } from '~/stores/project-schema';

export function usePrimitiveField(fieldId: MaybeRefOrGetter<GlobalPrimitiveFieldId | null | undefined>) {
	const { findPrimitiveFieldById } = useProjectSchemaStore();
	return computed(() => {
		const fieldIdValue = toValue(fieldId);
		return fieldIdValue ? findPrimitiveFieldById(fieldIdValue) : undefined;
	});
}
